"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ScaleContext_1 = require("../../context/ScaleContext");
const TreeColors_1 = require("./TreeColors");
function LevelNode({ signal, startY, levelHeight }) {
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    return ((0, jsx_runtime_1.jsx)("line", { x1: scaleX()(signal.delta), y1: startY, x2: scaleX()(signal.delta), y2: startY + levelHeight, stroke: TreeColors_1.TREE_LEVEL_COLORS[0] }, `startLevelNode_${signal.id}`));
}
exports.default = LevelNode;
